const collectionFilterSelectorText = `Allows you to select the filter of your choice. You can choose any of the following settings:
<ul style="padding-left:1rem">
<li><strong>Find First Match Data:</strong> to filter and display the first match found in the list of data.</li>
<li><strong>Find All Match Data:</strong> to filter and display all matches found in the list of data.</li>
<li><strong>Count:</strong> to display the number of items after counting them.</li>
<li><strong>Average:</strong> to calculate the average of data in a number field.</li>
<li><strong>Sum:</strong> to calculate the sum of data in a number field.</li>
<li><strong>Max:</strong> to filter and display data with the added maximum value in a number field.</li>
<li><strong>Min:</strong> to filter and display data with the added minimum value in a number field.</li>
</ul>`;

const collectionFilterSortByText = `Allows you to choose how data in a collection will get sorted after binding the filter to a CMS component. You can choose any of the following settings:
<ul style="padding-left:1rem">
<li><strong>Created At:</strong> Allows you to sort the data according to the date of creation.</li>
<li><strong>Updated At:</strong> Allows you to sort the data according to the date on which it was updated.</li>
<li><strong>ID:</strong> Allows you to sort the data according to their unique IDs.</li>
</ul>`;

const collectionFilterSortOrder = `Allows you to set the order in which data will display in a CMS component. You can choose any of the following settings:
<ul style="padding-left:1rem">
<li><strong>Ascending:</strong> Displays data in ascending order, i.e., from smallest to largest figure.</li>
<li><strong>Descending:</strong> Displays data in descending order, i.e., from largest to smallest figure.</li>
</ul>`;

const collectionItemText = `After creating the structure of a collection, you can either add, update or delete
data manually or bring or edit it dynamically using the events like Save Data,
Update Data & Delete Data. Data can also be transferred from other databases using
data sources like Airtable, Firestore, MongoDB, Google Sheet, Firebase Realtime
Database & REST API.`;
const robotTxt = `Allows you to create a robots.txt file to inform search engine crawlers which
URLs to access on your site. It is usually created to avoid overloading your
site with requests.`;
const loadingIconText = `We have created a bunch of loading icons for you to choose from. If you want you
also choose to show no loading icon by selecting the option, none.`;
const snippetShapshotText = `Snippet snapshot is like a screenshot that keeps all the content in its original
state even if the snippet used to create it gets modified or deleted. All the
snippet Snapshots that you’ve created are displayed here. Using them you can
create new snippets, modal and custom segments faster.`;
const customJSText = `You can easily add custom features and functionalities in your web app by inserting custom 
JavaScript code. You can also add custom features by using JavaScript URL and Script tags.`;
const customCSS = `Custom CSS allows you to add custom classes by adding CSS code to custom design your app or website. 
In Drapode, you can write the CSS code, create Global Styles using DrapCode’s CSS builder form and even overwrite the 
existing CSS styles.`;
const pageSnapshotText = `Allows you to make a copy of a page that stays the same even if you have made
changes in the page. It also helps you to revert to the previous state of the
page, in case something goes wrong while doing new changes. To create a page
snapshot, you have to go to the advanced settings of the page.`;
const pageSettingText = ` create an external API. To get data from any third-party integration like Xano, Airtable etc. 
you need to create an External API. External APIs are modules that are used to create a REST API such as GET API, POST API, DELETE, etc. You may also use an existing API too. Give a name to your external API.`;
const appConstantText = `As the name suggests, constant is a value that stays fixed. Therefore, the
constant settings allow you to apply a constant or fixed value to a filter for
filtering the data entries with that constant value.`;
const envConstantMsg = `Name cannot have space or any special character between words, only underscore(_) is allowed`;
const encryptionText = 'Allow you encrypt data';
const notificationSettingText =
  'Allows you change the default behaviour of the notification banner.';
const localizationText = 'Allow localiztion of text of the website';
const enablePWA = 'Enable PWA for the project';
const disablePWA = 'Disable PWA for the project';
const appConfigText = '';
const enableDeveloperKey = 'Enable Developer Key for the project';
const disableDeveloperKey = 'Disable Developer Key for the project';
const enableIt = 'Yes, enable it!';
const disableIt = 'Yes, disable it!';
const wantBeAbleToRevert = "You won't be able to revert this.";
const selectVersionToCreate = 'Select source version from which new version will be created';
const pagesText = '';
const profilerText = '';
const collectionFilterIsPrivate = `Defines the privacy settings of the filter:
<ul style="padding-left:1rem">
<li><strong>Checked:</strong> Makes the filter only available for the logged-in users to use.</li>
</ul>`;

const collectionFilterIsPrivateText = 'Checked - Restricts filter access to logged-in users only.';
export {
  collectionFilterSelectorText,
  collectionFilterSortByText,
  collectionFilterSortOrder,
  collectionItemText,
  robotTxt,
  loadingIconText,
  snippetShapshotText,
  customJSText,
  customCSS,
  pageSnapshotText,
  pageSettingText,
  appConstantText,
  envConstantMsg,
  encryptionText,
  notificationSettingText,
  localizationText,
  enablePWA,
  disablePWA,
  appConfigText,
  enableDeveloperKey,
  disableDeveloperKey,
  enableIt,
  disableIt,
  wantBeAbleToRevert,
  selectVersionToCreate,
  pagesText,
  profilerText,
  collectionFilterIsPrivate,
  collectionFilterIsPrivateText,
};
